import controller from './page.controller';
import templateBase from './templates/page-base.view.html';


let LoginComponent = {
  template : changeTemplate,
  controller,
  bindings : {
    shCtrl : '<',
    rPass:'@'
  }
};


changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
//   let response = SessionService.get('components');
//   if(__env.adaptative){
//     return templateAD;
//   } else {
//     if(response.LOGIN.component == 'template_t1'){
      // return templateT1;
   //  }else{
      return templateBase;
   //  }
//   }
}

export default LoginComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/page/page.component.js
 **/